const SUPERADMIN = 'superadmin';

export function getManagementUser() {
  try {
    return JSON.parse(sessionStorage.getItem('adminUser') || 'null');
  } catch {
    return null;
  }
}

export function isManagementSession() {
  const token = sessionStorage.getItem('adminToken');
  const user = getManagementUser();
  return Boolean(token && user?.role === SUPERADMIN);
}

export function clearManagementSession() {
  sessionStorage.removeItem('adminToken');
  sessionStorage.removeItem('adminUser');
}

export function clearFrontendSession() {
  sessionStorage.removeItem('authToken');
  sessionStorage.removeItem('user');
}

export function setManagementSession(token, user) {
  clearFrontendSession();
  sessionStorage.setItem('adminToken', token);
  sessionStorage.setItem('adminUser', JSON.stringify(user));
}
